import type { ConfigType } from '@plone/registry';

import { blocoPermitido } from 'volto-ministerio-publico-federal/helpers/Permissoes';

// Um mesmo objeto de bloco aparece em mais de um `blocksConfig` (os blocos
// de container reaproveitam a config global): não pode ser envolvido duas vezes.
const envolvidos = new WeakSet<object>();

const envolver = (blocksConfig: Record<string, any> | undefined) => {
  Object.values(blocksConfig ?? {}).forEach((bloco) => {
    if (!bloco?.id || envolvidos.has(bloco)) return;
    envolvidos.add(bloco);

    const original = bloco.restricted;
    // `restricted: true` fica como está: o catálogo do painel de perfis usa
    // esse valor para deixar de fora os blocos que ninguém adiciona.
    if (original !== true) {
      bloco.restricted = (args: any) => {
        const restrito =
          typeof original === 'function' ? original(args) : Boolean(original);
        if (restrito) return true;
        // `user` é o `state.users.user` (@users/{id}), que traz `mpf_permissoes`
        // do próprio usuário. Sem ele a UI não restringe; o backend barra.
        return !blocoPermitido(args?.user?.mpf_permissoes, bloco.id);
      };
    }

    envolver(bloco.blocksConfig);
  });
};

/**
 * Perfis de acesso: esconde do BlockChooser os blocos fora da allowlist do
 * perfil, preservando o `restricted` que cada bloco já tinha.
 */
export const aplicarPermissoesBlocos = (config: ConfigType) => {
  envolver(config.blocks.blocksConfig);
  return config;
};

export default aplicarPermissoesBlocos;
